import React, { useState, useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';

import './novoEquipamento.css';

function NovoEquipamento(props) {

    const history = useHistory();

    const location = useLocation();
    const {id} = location.state || {};

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    const [codEqp, setCodEqp] = useState('');
    const [nomEqp, setNomEqp] = useState('');
    const [desEqp, setDesEqp] = useState('');
    const [layEqp, setLayEqp] = useState('');
    const [sitEqp, setSitEqp] = useState('');
    const [idePro, setIdePro] = useState('');

    const [updIns, setUpdIns] = useState('I');
    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('N');

    const [placeId, setPlaceId] = useState("Digite sequência do equipamento para edição ou deixe em branco para adicionar");

    const verificarCampos = async () => {

        if (nomEqp.trim() === '') {
            setMensagem("Atenção deve ser inserido o nome do equipamento!")
            return;
        }

        if (desEqp.trim() === '') {
            setMensagem("Atenção deve ser inserida uma descrição válida!");
            return;
        }

        if (layEqp.trim() === '') {
            setMensagem("Atenção deve ser inserido o layout do equipamento!");
            return;
        }

        if (sitEqp.trim() === '') {
            setMensagem("Atenção deve ser inserida situação do equipamento!");
            return;
        }

        setMensagem("");
    };

    const buscandoEquipamento = async (codEqp) => {

        verificandoToken();

        if (codEqp) {
            try {

                const token = localStorage.getItem('token');

                const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos/espec", {
                    headers: {
                        Authorization: `${token}`
                    },
                    params: {
                        codEqp: codEqp
                    }
                });

                if (response.data.length > 0) {

                    setUpdIns("U");

                    setCodEqp(codEqp);
                    setNomEqp(response.data[0].nomeqp);
                    setDesEqp(response.data[0].deseqp);
                    setLayEqp(response.data[0].layeqp);
                    setSitEqp(response.data[0].siteqp);
                    setIdePro(response.data[0].idepro);
                } else {

                    setUpdIns("I");

                    setCodEqp("");
                    setNomEqp("");
                    setDesEqp("");
                    setLayEqp("");
                    setSitEqp("");
                    setIdePro("");
                }

            } catch (error) {
                console.error('Erro ao buscar dados:', error);
            }
        }
    };

    useEffect(() => {

        verificar();

        if (id) {
            setPlaceId(id);
            setCodEqp(id);
            buscandoEquipamento(id);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const inserindoEquipamento = async () => {

        verificarCampos();
        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            if (updIns === 'I') {
                await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos",
                    {nomEqp, desEqp, layEqp, sitEqp, idePro},
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });
            } else {

                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos",
                    {nomEqp, desEqp, layEqp, sitEqp, idePro, codEqp},
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });

            }
            setMensagem('');
            setSucesso('S');
        } catch (error) {
            setMensagem('Erro ao inserir/atualizar dados');
            setSucesso('N');
        }
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo">
            <div className="col-4">
                <h1>{updIns === 'U' ? "Alterar" : "Cadastrar"} Equipamento</h1>
            </div>
            <form>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Sequência Equipamento</label>
                    <input type="email" onChange={(e) => buscandoEquipamento(e.target.value)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder={placeId} />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Nome</label>
                    <input type="email" onChange={(e) => setNomEqp(e.target.value)} value={nomEqp} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nome Equipamento" />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Descrição</label>
                    <input type="email" onChange={(e) => setDesEqp(e.target.value)} value={desEqp} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Descrição Equipamento " />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Layout para cadastro hardware</label>
                    <textarea type="email" className="form-control" rows={10} onChange={(e) => setLayEqp(e.target.value)} value={layEqp} id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Layout Equipamento" />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Identificação Unica para Busca de Produto</label>
                    <input type="email" className="form-control" rows={10} onChange={(e) => setIdePro(e.target.value)} value={idePro} id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Identificação Equipamento" />
                </div>

                <div className="form-row row mb-1">
                    <div className="form-group col">
                        <label for="inputEstado">Situação</label>
                        <select id="inputEstado" className="form-control" value={sitEqp} onChange={(e) => { setSitEqp(e.target.value) }}>
                            <option selected>Escolher...</option>
                            <option value={"A"}>Ativo</option>
                            <option value={"I"}>Inativo</option>
                        </select>
                    </div>
                </div>

                <button onClick={inserindoEquipamento} type="button" className="btn btn-secondary btn-acao mt-4">Salvar</button>
            </form>

            {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
            {sucesso === 'S' ? <Redirect to='/home' /> : null}
            </div>
            </main>
        </div>
    );
}

export default NovoEquipamento;